import React, { useEffect, useState } from "react";
import {
  BookFill,
  CameraVideoFill,
  CameraVideoOffFill,
  CardChecklist,
  Display,
  DisplayFill,
  MicFill,
  MicMuteFill,
} from "react-bootstrap-icons";
import ModalLeaveSession from "./Modal/ModalLeaveSession";
import { classNames } from "../../../../general/functions/propsComponent";
import { SetEndSession } from "../../actions/sessionMethodActions";
import { useDispatch } from "react-redux";

export default function AssessorControls(props) {
  const {
    setJoin,
    setShareScreen,
    setMute,
    tracksState,
    isShareScreen,
    isOtherShareScreen,
    errorInfo,
    setShowGuide,
    setShowListAnswer,
    btnAvailable = {
      shareScreen: true,
      guide: true,
      listAnswer: true,
    },
  } = props;
  const dispatch = useDispatch();

  const [isShareScreenProcess, setIsShareScreenProcess] = useState(false);
  const mute = async (type) => {
    if (type === "audio") {
      setMute({ type: "audio", status: !tracksState.audio });
    } else if (type === "video") {
      setMute({ type: "video", status: !tracksState.video });
    }
  };
  const leaveChannel = async () => {
    setJoin(false);
  };
  const handleShareScreen = () => {
    setIsShareScreenProcess(true);
    setShareScreen();
  };
  useEffect(() => {
    setIsShareScreenProcess(false);
  }, [isShareScreen, errorInfo]);
  return (
    <div className="flex gap-2 justify-between">
      <div className="flex gap-2">
        <button
          className={classNames(
            tracksState.audio ? "on" : "",
            "btn-secondary p-2 w-16 flex flex-col justify-center items-center"
          )}
          onClick={() => mute("audio")}
        >
          {tracksState?.audio ? (
            <MicFill size={16} />
          ) : (
            <MicMuteFill size={16} className="text-red-500" />
          )}{" "}
          <p className="text-xs font-normal">Mic</p>
        </button>

        <button
          className={classNames(
            tracksState.video ? "on" : "",
            "btn-secondary p-2 w-16 flex flex-col justify-center items-center"
          )}
          onClick={() => mute("video")}
        >
          {tracksState?.video ? (
            <CameraVideoFill size={16} />
          ) : (
            <CameraVideoOffFill size={16} className="text-red-500" />
          )}{" "}
          <p className="text-xs font-normal">Cam</p>
        </button>
      </div>

      <div className="flex gap-2">
        {btnAvailable?.shareScreen && (
          <button
            disabled={isOtherShareScreen || isShareScreenProcess}
            className={classNames(
              "btn-secondary p-2 w-auto flex flex-col justify-center items-center whitespace-nowrap",
              isOtherShareScreen || isShareScreenProcess
                ? "cursor-not-allowed"
                : ""
            )}
            onClick={() => handleShareScreen()}
          >
            {isShareScreen ? (
              <DisplayFill size={16} className="text-green-500" />
            ) : (
              <Display
                size={16}
                className={classNames(
                  isOtherShareScreen || isShareScreenProcess
                    ? "text-gray-400"
                    : ""
                )}
              />
            )}
            <p
              className={classNames(
                "text-xs font-normal",
                isOtherShareScreen || isShareScreenProcess
                  ? "text-gray-400"
                  : ""
              )}
            >
              Share Screen
            </p>
          </button>
        )}
        {btnAvailable?.guide && (
          <button
            className={classNames(
              "btn-secondary  p-2 w-16 flex flex-col justify-center items-center whitespace-nowrap"
            )}
            onClick={() => setShowGuide()}
          >
            <BookFill size={16} />
            <p className="text-xs font-normal">Guide</p>
          </button>
        )}
        {btnAvailable?.listAnswer && (
          <button
            className={classNames(
              "btn-secondary  p-2 w-auto flex flex-col justify-center items-center whitespace-nowrap"
            )}
            onClick={() => setShowListAnswer()}
          >
            <CardChecklist size={16} />
            <p className="text-xs font-normal">List Answer</p>
          </button>
        )}
        {/* <button
          className={classNames(
            "btn-secondary p-2 w-auto flex flex-col justify-center items-center whitespace-nowrap"
          )}
          onClick={() => handleShareScreen()}
        >
          <ExclamationTriangleFill size={16} />
          <p className="text-xs font-normal">Report</p>
        </button> */}
      </div>
      <div className="flex gap-2">
        <ModalLeaveSession
          handleChoosen={(v) => {
            console.log("triger end", v);
            if (v == "LEAVE") {
              leaveChannel();
            }
            if (v == "LEAVE_ALL") {
              dispatch(SetEndSession());
            }
          }}
        />
      </div>
    </div>
  );
}
